module.exports = __webpack_public_path__ + "img/img_app_1.d86a6910.jpg";